import { makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import { useAddToCart } from '../../../api/shoppingCart';
import AddToCartButtonToQty from '../../../components/AddToCartButtonToQty';

export interface ProductDetailAddToCartProps extends StandardDivProps<ProductDetailAddToCartClassKey> {
  product: ProductDetailProduct;
}

export type ProductDetailAddToCartClassKey = 'root';

const themeSettings = { name: 'ProductDetailAddToCart' };
const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      maxHeight: theme.spacing(4),
      justifyContent: 'flex-end',
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'center',
        paddingTop: theme.spacing(1),
      },
    },
    custom: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  }),
  themeSettings,
);

const ProductDetailAddToCart = React.forwardRef<HTMLDivElement, ProductDetailAddToCartProps>(
  ({ className, classes: pClasses, product }, ref) => {
    const classes = useStyles({ classes: pClasses });

    const { addToCart, ...addToCartProps } = useAddToCart({
      forcePreventDecrement: true,
      product,
    });

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        <div className={clsx(classes.custom, className)}>
          <AddToCartButtonToQty onAddToCart={addToCart} {...addToCartProps} product={product} />
        </div>
      </div>
    );
  },
);

ProductDetailAddToCart.displayName = 'ProductDetailAddToCart';

export default withThemeProps(themeSettings)(ProductDetailAddToCart);
